import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import update from "@beeldit/core/services/update";
import { DetailsByCustomerActionContext } from "./DetailsByCustomerActionContext";

function useUpdate(modelConfig: any) {
  const { element, setBackendFormErrors } = useContext(DetailsByCustomerActionContext);
  const errorHandler = useErrorHandler();

  return (onSuccess: any) => {
    update(modelConfig.endpoint, element.id, element)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useUpdate;
